import { useDashboardUser } from "~/modules/dashboard/hooks/useDashboardUser.tsx";
import { useUsersActiveStaffings } from "~/modules/project/api/staffing/staffingQueries.ts";

export function useActiveStaffings() {
	const user = useDashboardUser();

	return useUsersActiveStaffings(user?.id ?? "");
}
